<template>
  <div class="product-header">
    <div class="product-image" :style="{backgroundImage: 'url(' + product.imageUrl + ')'}"></div>
    <div class="product-titles">
      <div class="product-title">{{product.title}}</div>
      <div class="product-subtitle">{{product.subtitle}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductHeader",
  props: ["product"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-header {
  display: flex;
  width: calc(100% - 100px);
}

.product-image {
  width: 60px;
  min-width: 60px; /*Needed for IE */
  height: 60px;
  margin-right: 10px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}

.product-titles {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 80px);
}

.product-title {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 700;
  overflow-wrap: break-word;
  color: #323232;
}

.product-subtitle {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>